var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-vpsmp"},[_c('div',{staticClass:"c-vpsmp-main"},[_c('div',{ref:"containerRef",staticClass:"c-vpsmp-container"},_vm._l((_vm.pricingList),function(item,index){return _c('single-pkg',{key:index,ref:"singlePkgRef",refInFor:true,staticClass:"c-vpsmp-item",attrs:{"pkg":item,"isLiuziPage":_vm.isLiuziPage}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }